// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"83ca36c0","455":"e6276a04","977":"8bc4faf9"}[chunkId] + ".chunk.js";
};